<template>
  <div>
    <gmap-autocomplete
      @place_changed="placeChange"
      @input="valueChange"
      :value="place"
      :class="{'is-danger' : isError}"
      :disabled="disabled"
      :componentRestrictions="{ country: listeAlpha2CodePaysLimiteAutocompleteGoogle }"
      class="input" type="search" placeholder=""
      selectFirstOnEnter/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_AFFIXE2 } from '@/configuration/paramsAffixe2';

const Parametrage = createNamespacedHelpers('parametrage');

export default {
  props: {
    isError: Boolean,
    libelle: String,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      place: '',
    };
  },
  watch: {
    libelle(val) {
      this.place = val;
    }
  },
  computed: {
    ...Parametrage.mapGetters({
      paramAffixe2: 'paramAffixe2',
    }),
    listeAlpha2CodePaysLimiteAutocompleteGoogle() {
      const param = this.paramAffixe2[PARAMETRES_AFFIXE2.listeAlpha2CodePaysLimiteAutocompleteGoogle.key];
      if (!param || !param.length) return [];
      return param.split('|').map(el => el.trim());
    },
  },
  methods: {
    placeChange(place) {
      if (!place.geometry) {
        let namePlace = '';
        if (place.name) namePlace = place.name;
        let messErreur = this.$t('general.msgErrorAutoCompleteGmap', {
          name: namePlace,
        });
        this.$emit('error', messErreur);
        return;
      }
      const coordonnees = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      let ville = '';
      let codePostal = '';
      let pays = '';
      let numberRue = '';
      let libelleRue = '';
      place.address_components.forEach(el => {
        el.types.forEach(type => {
          if (type === 'locality') ville = el.long_name;
        })
        el.types.forEach(type => {
          if (type === 'postal_code') codePostal = el.long_name;
        })
        el.types.forEach(type => {
          if (type === 'country') pays = el.long_name;
        })
        el.types.forEach(type => {
          if (type === 'street_number') numberRue = el.long_name;
        })
        el.types.forEach(type => {
          if (type === 'route') libelleRue = el.long_name;
        })
      })
      this.$emit('place_change', {
        coordonnees: coordonnees,
        libelle: place.formatted_address,
        ville,
        codePostal,
        pays,
        numberRue,
        libelleRue,
        adresse1: [numberRue, libelleRue].filter(libelle => !!libelle).join(', '),
        adresse2: '',
        adresse3: '',
      });
    },
    valueChange(value) {
      if (value.data === null || value.data === undefined) {
        this.$emit('place_change', null);
      }
    }
  },
  mounted() {
    this.place = this.libelle;
  },
  destroyed() {
    this.place = '';
  }
}
</script>

<style>

</style>
